import React, { useState } from 'react'
import messages from './messages'
import { useIntl } from 'react-intl'
import { Modal, Button, Input, TextArea, Person } from '@arnsbogroup/react-voicearchive'
import NiceModal, { useModal } from '@ebay/nice-modal-react'

export default NiceModal.create(({ order, selectedTasks }) => {
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [subject, setSubject] = useState(order.name)
  const { formatMessage } = useIntl()
  const modal = useModal()
  
  const suppliers = selectedTasks
    .filter(({ supplier }) => !!supplier && typeof supplier !== 'string')
    .map(({ supplier }) => supplier)

  const onSubmit = (event) => {
    event.preventDefault()
    setLoading(true)

    fetch(`/message/sendSuppliersMessage.html`, {
      method: 'POST',
      body: new URLSearchParams({
        subject,
        message,
        supplierIds: suppliers.map(({ uid }) => uid).join(','),
        orderId: order.uid,
      })
    })
      .then(() => {
        modal.resolve()
        modal.remove()
        setLoading(false)
      })
      .catch((error) => toastr.error(error))
  }

  return (
    <Modal
      show={modal.visible}
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      title={formatMessage(messages.title)}
    >
      <div className="my-4">
        <div className="grid grid-cols-2 gap-3">
          { suppliers.map((supplier) => (
            <div key={supplier.uid}>
              <Person {...supplier } />
            </div>
          )) }
        </div>
      </div>

      <form onSubmit={onSubmit} className="space-y-4">
        <Input
          label="Subject"
          value={subject}
          onChange={({ target: { value } }) => setSubject(value)}
        />

        <TextArea
          label="Message"
          value={message}
          onChange={({ target: { value } }) => setMessage(value)}
        />

        <Button
          type="submit"
          size="sm"
          disabled={!message.length || !subject.length || loading}
        >
          { loading ? 'Sending..' : `Send to all ${suppliers.length} suppliers` }
        </Button>
      </form>
    </Modal>
  )
})
